<template>
  <BaseLayout>
    <template #primarySection>
      <section
        aria-labelledby="primary-heading"
        class="flex h-full min-w-0 flex-1 flex-col overflow-y-auto lg:order-last bg-secondary p-10"
      >
        <slot class="mt-12" />
        <SharedCustomNotification />
      </section>
    </template>
  </BaseLayout>
</template>

<script setup lang='ts'>
import BaseLayout from '~/components/shared/BaseLayout.vue'
import { useCurrentUserSession } from '~/composables/states'
import { useCurrentServiceprovider } from '~/composables/useCurrentServiceprovider'

const { userOrganization, isServiceproviderUser, mainRole } = useCurrentUserSession()
const route = useRoute()
const { $api } = useNuxtApp()
const { initializeServiceprovider } =
  useCurrentServiceprovider()

storeProviderUUID()

async function storeProviderUUID (): Promise<void> {
  let providerUUID = null

  if (isServiceproviderUser) {
    providerUUID = userOrganization
  } else if (mainRole === 'client') {
    // get serviceprovider uuid of client
    const res = await $api.client.getClientInfo(userOrganization)
    providerUUID = res.data.serviceproviderUUID
  }

  if (!providerUUID) {
    providerUUID = route.params?.providerId
  }

  await initializeServiceprovider(providerUUID)
}
</script>

<style></style>
